import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import 'react-hawksearch/dist/esm/react-hawksearch.css';

import { parseLocation, Hawksearch, QueryStringListenerSF, TrackingEvent } from 'react-hawksearch';
import PreviewFacetRail from 'components/results/PreviewFacetRail';
import PreviewResults from 'components/results/PreviewResults';
import MerchandisingBanner from 'components/merchandising-banner/merchandisingBanner';

interface ResultsPageProps {
	dataDisplayMode: string | null;
}

window.addEventListener('load', () => {
	const component = document.getElementById('react-app');
	if (component) {
		const baseAPI = component.getAttribute('data-base-api');
		const apiUrlObj = {
			searchApi: component.getAttribute('data-search-api'),
			autocompleteApi: component.getAttribute('data-autocomplete-api'),
		};

		if (!baseAPI || !apiUrlObj) {
			return false;
		}

		const hawkConfig = {
			clientGuid: component.getAttribute('data-client-guid'),
			baseAPI,
			searchPageUrl: component.getAttribute('data-search-page'),
			indexName: component.getAttribute('data-index-name'),
			trackEventUrl: component.getAttribute('data-tracking-api'),
			addToCartURL: component.getAttribute('data-addtocart-api'),
			compareItemURL: component.getAttribute('data-compare-api'),
			dataSiteDirectory: component.getAttribute('data-site-directory'),
			dataSearchQuery: component.getAttribute('data-search-query'),
			dataDisplayMode: component.getAttribute('data-display-mode'),
			facetNavigationMode: component.getAttribute('facet-navigation-mode'),
			...apiUrlObj,
		};

		function ResultsPage({ dataDisplayMode }: ResultsPageProps) {
			const searchRequest = parseLocation(location, '/search', hawkConfig.dataSiteDirectory);
			searchRequest.query = hawkConfig.dataSearchQuery;

			if (!hawkConfig.facetNavigationMode) {
				hawkConfig.facetNavigationMode = 'leftfacetnav';
			} else if (hawkConfig.facetNavigationMode !== 'topfacetnav') {
				hawkConfig.facetNavigationMode = 'leftfacetnav';
			}

			useEffect(() => {
				TrackingEvent.track('pageload', { pageType: 'custom' });
			}, []);
			return (
				<Hawksearch
					config={{
						clientGuid: hawkConfig.clientGuid,
						dashboardUrl: '',
						indexName: hawkConfig.indexName,
						isInPreview: true,
						// searchPageUrl: 'index.html',
						searchPageUrl: hawkConfig.dataSiteDirectory,
						apiUrl: hawkConfig.baseAPI || 'https://searchapi-dev.americaneagle.com',
						trackEventUrl: hawkConfig.trackEventUrl,
						autocompleteUrl: apiUrlObj.autocompleteApi,
						searchUrl: apiUrlObj.searchApi,
						dataSiteDirectory: hawkConfig.dataSiteDirectory,
					}}
					initialSearch={{ ...searchRequest }}
				>
					<QueryStringListenerSF />
					<div className="hawk">
						<div className={'hawk__body ' + hawkConfig.facetNavigationMode}>
							<MerchandisingBanner BannerZone={'BannerTop'} />
							<div className="header">
								<MerchandisingBanner BannerZone={'FeaturedLeftTop'} />
								<PreviewFacetRail />
								<MerchandisingBanner BannerZone={'FeaturedLeftBottom'} />
							</div>
							<div className="content">
								<PreviewResults />
								<MerchandisingBanner BannerZone={'FeaturedBottom'} />
								<MerchandisingBanner BannerZone={'FeaturedBottom2'} />
							</div>
						</div>
					</div>
				</Hawksearch>
			);
		}
		ReactDOM.render(<ResultsPage dataDisplayMode={hawkConfig.dataDisplayMode} />, component);
	}

	return;
});
